var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 354.346,
    height: 659.055,
    viewBox: "0 0 354.346 659.055",
    overflow: "visible",
    enableBackground: "new 0 0 354.346 659.055",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074BD",
    d: "M117.151,349.592c0,0-17.265,10.049,12.301,13.44 c35.824,4.09,54.13,3.501,93.596-3.959c0,0,10.397,6.504,24.892,12.137C159.439,409.127,47.644,369.013,117.151,349.592 L117.151,349.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074BD",
    d: "M106.331,300.104c0,0-19.367,14.339,10.221,17.397 c38.271,3.951,68.483,4.275,120.792-5.792c0,0,7.218,7.332,18.585,11.339C148.943,354.342,29.782,325.51,106.331,300.104 L106.331,300.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M197.494,216.145c21.818,25.115-5.721,47.697-5.721,47.697 s55.367-28.577,29.945-64.38c-23.752-33.373-41.962-49.951,56.623-107.124C278.342,92.338,123.587,130.979,197.494,216.145 L197.494,216.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074BD",
    d: "M314.542,386.202c0,0,12.781,10.536-14.077,18.684 c-51.071,15.469-212.604,20.135-257.47,0.619c-16.117-7.02,14.121-16.75,23.635-18.805c9.92-2.146,15.584-1.754,15.584-1.754 c-17.937-12.631-115.935,24.807-49.772,35.544C212.871,449.736,361.337,407.317,314.542,386.202L314.542,386.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074BD",
    d: "M125.46,248.822c0,0-82.155,19.519-29.092,26.613 c22.412,2.999,67.063,2.309,108.685-1.183c34.006-2.854,68.133-8.958,68.133-8.958s-11.982,5.14-20.657,11.06 C169.085,298.301,7.917,288.08,54.322,265.642C93.549,246.665,125.46,248.822,125.46,248.822L125.46,248.822z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074BD",
    d: "M272.846,331.198c84.818-44.063,45.597-86.412,18.223-80.708 c-6.694,1.397-9.697,2.607-9.697,2.607s2.494-3.907,7.243-5.588c54.155-19.03,95.794,56.146-17.464,85.919 C271.15,333.428,272.453,332.248,272.846,331.198L272.846,331.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M221.719,0c0,0,46.963,46.99-44.557,119.227 c-73.393,57.969-16.734,91.009-0.026,128.778c-42.845-38.653-74.271-72.684-53.192-104.352 C154.898,97.174,240.663,74.632,221.719,0L221.719,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074BD",
    d: "M133.799,450.637c81.397,5.204,206.426-2.896,209.385-41.415 c0,0-5.688,14.602-67.276,26.188c-69.481,13.081-155.197,11.558-206.016,3.167C69.892,438.577,80.303,447.194,133.799,450.637 L133.799,450.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M339.426,519.716h-2.479v-1.385h6.676v1.385h-2.469v6.928h-1.729 V519.716L339.426,519.716L339.426,519.716z M352.756,520.067h-0.032l-2.461,6.576h-1.132l-2.446-6.576h-0.025v6.576h-1.638v-8.313 h2.402l2.264,5.885l2.271-5.885h2.388v8.313h-1.59V520.067L352.756,520.067z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M120.461,597.813c-7.676,6.654-15.793,10.396-23.079,10.396 c-10.378,0-16.007-6.236-16.007-16.216c0-10.803,6.027-18.71,30.163-18.71h8.923V597.813L120.461,597.813L120.461,597.813z  M141.65,621.716V547.72c0-18.915-10.787-31.396-36.782-31.396c-15.168,0-28.467,3.75-39.278,8.525l3.111,13.106 c8.515-3.127,19.526-6.031,30.337-6.031c14.978,0,21.423,6.031,21.423,18.505v9.356h-7.485c-36.383,0-52.798,14.11-52.798,35.336 c0,18.285,10.819,28.682,31.185,28.682c13.088,0,22.87-5.405,32.001-13.315l1.663,11.228H141.65L141.65,621.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M212.362,621.716h-26.423l-31.807-103.502h23.077l19.743,63.6 l4.391,19.109c9.965-27.639,17.032-55.701,20.566-82.709h22.445C238.352,552.294,227.523,589.706,212.362,621.716L212.362,621.716z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M313.755,597.813c-7.701,6.654-15.82,10.396-23.086,10.396 c-10.382,0-16.011-6.236-16.011-16.216c0-10.803,6.039-18.71,30.154-18.71h8.942V597.813L313.755,597.813L313.755,597.813z  M334.951,621.716V547.72c0-18.915-10.818-31.396-36.789-31.396c-15.188,0-28.484,3.75-39.295,8.525l3.116,13.106 c8.519-3.127,19.545-6.031,30.355-6.031c14.96,0,21.416,6.031,21.416,18.505v9.356h-7.485c-36.391,0-52.801,14.11-52.801,35.336 c0,18.285,10.804,28.682,31.169,28.682c13.099,0,22.862-5.405,32.018-13.315l1.674,11.228H334.951L334.951,621.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EA2D2E",
    d: "M36.941,639.306c-6.037,8.821-15.8,15.809-26.479,19.749 L0,646.731c8.135-4.178,15.103-10.912,18.345-17.182c2.796-5.589,3.96-12.773,3.96-29.971V481.398h22.519v116.551 C44.824,620.95,42.988,630.249,36.941,639.306L36.941,639.306z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.4e4de258b57580459f84cc3ca0c6ae4b.svg";
export { ForwardRef as ReactComponent };